import React, { Fragment } from "react";
import { Form, InputGroup, Button } from "react-bootstrap";
import SVG from "react-inlinesvg";
import "../../../../../assets/sass/pages/scouting/shared-done-modal.scss";

import searchIcon from "../../../../../assets/svg/actions/icn-search.svg";
import addIcon from "../../../../../assets/svg/actions/icn-plus-20px.svg";
import avatarImg from "../../../../../assets/img/demo/player-avatar-1.png";


import check from "../../../../../assets/svg/actions/icn-check-green-20px.svg";
import share from "../../../../../assets/svg/actions/icn-share-20px.svg";
import SA_ShareVideo from "./SA_ShareVideoDone";
import ParticipantsModal from "../../../../ui/modals/ParticipantsModal";

class ShareVideoModal extends ParticipantsModal {
    constructor(props) {
        super(props)

        this.allParticipants = Array.from(Array(25).keys())
            .map((item, index) => ({
                id: index,
                key: index,
                avatar: avatarImg,
                name: 'Calvin Cooper',
                role: 'Scout | Canberry Football Club',
                selected: false,
            }));

        this.state = {
            participants: this.allParticipants
        };
    }

    titles = {
        heading: 'Share Video',
        sub_heading: 'Please search name or enter email you want to share the video.',
        submit: 'Share Video',
    }

    insertContent = () => {
        return (
            <>
                <InputGroup className="input-group-flat-lg mt-3 mb-3">
                    <Form.Control as="textarea" rows={3} name="desc" placeholder="Add message to be shared with video" className="input input-flat" />
                </InputGroup>

                <InputGroup className="input-group-flat-lg mt-3 mb-3">
                    <Form.Control
                        name="text"
                        placeholder="Seach Name or Enter Email"
                        className="input input-flat input-lg"
                        onChange={this.handleSearch}
                        onKeyDown={this.handleAddUser}
                    />
                    <InputGroup.Append>
                        {this.state.participants.length !== 0 ?
                            <InputGroup.Text>
                                <i><SVG src={searchIcon} /></i>
                            </InputGroup.Text> :
                            <InputGroup.Text>
                                <i><SVG src={addIcon} /></i>
                            </InputGroup.Text>}
                    </InputGroup.Append>
                </InputGroup>
            </>
        )
    }

    onSubmit = () => {
        new SA_ShareVideo().fire({
            onOpen: () => {
                this.closeModal();
            }
        }, { sharedWith: this.state.participants.length })
    }

    // toggleSelected = (index, active) => {
    //     var participants = this.state.participants.map((item) => ({
    //         ...item,
    //         selected: item.index === index ? active : item.selected
    //     }));

    //     this.setState({
    //         participants: participants
    //     })
    // }

    handleSearch = (e) => {
        const searchValue = e.target.value;

        const filteredParticipants = this.allParticipants.filter(participat => participat.name.includes(searchValue))

        this.setState({
            participants: searchValue ? filteredParticipants : this.allParticipants
        })
    }

    handleAddUser = (e) => {
        if (e.keyCode == 13) { // Enter Key Pressed
            const addedUser = e.target.value;

            this.setState(prevState => ({
                participants: [
                    {
                        id: addedUser,
                        avatar: avatarImg,
                        name: addedUser,
                        role: 'Scout | Canberry Football Club',
                        selected: true,
                    }
                ]
            }))
        }
    }

    activeIcon  = () => {
        return check;
    }

    inactiveIcon = () => {
        return share;
    }

    extraClassName = "share-modal"
};

export default ShareVideoModal;